const PixellComponent = () => {
  return (
    <div className="xl:max-w-6xl mx-auto">
      <div
        className="relative bg-cover bg-center text-white items-center flex flex-col md:flex-row md:justify-around md:items-end space-y-8 md:space-y-0 md:space-x-8  pt-6"
        style={{
          backgroundImage: "url('/assests/images/LandingPage/bg-Intro1.webp')",
          borderRadius: "3rem", // Update this path with your background image's URL
        }}
      >
        {" "}
        {/* Left Section - Text */}
        <div className="flex flex-col items-center md:items-start space-y-4 max-w-lg py-20 ">
          <h2 className="text-3xl font-extrabold ">Introducing Pixell</h2>
          <p className="text-[1.2rem] text-center md:text-start leading-relaxed text-[#eaeaea]">
            A cutting edge platform which not only appoints signage vendors and
            service providers at a hyperlocal level , but also offers agility,
            visibility and efficiency to the Brands
          </p>
          {/* <button className="bg-black text-white py-2 px-6 rounded-lg shadow-lg hover:bg-gray-800">
            Get Started →
          </button> */}
        </div>
        {/* Right Section - Image */}
        <div className="relative flex-shrink-0 ">
          <img
            src="/assests/images/LandingPage/campaign-card1.webp"
            alt="Tribal Art Campaign"
            className=" w-80 h-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default PixellComponent;
